import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService, SessionService } from '@shared/services';
import { MessageService } from '@pages/components/message/message.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    private _notification: MessageService,
    private _session: SessionService
  ) {}

  showNotification() {
    this._notification.create('danger', `Oops someting's not right`, {
      Position: 'top-right',
      Style: 'flip',
      Duration: 3000
    });
  }

  checkRequest(url: string) {
    const split = url.split('/');
    return !!split.find(i => i === 'access') || false;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        this.checkRequest(request.url);
        if (err.status === 401) {
          if (this.checkRequest(request.url)) {
            // auto logout if 401 response returned from api
            this.authenticationService.logout();
            location.reload(true);
            return;
          }
          // auto update the token if 401 response returned from api
          this._session.updateToken();
        } else if (err.status === 500) {
          this.showNotification();
        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
